import type { UseQueryOptionsGlobal } from "@pinia/colada";

// `ssrCatchError: true` keeps query errors inside `state.error` on SSR instead
// of letting them propagate to setup. Propagated errors trigger Nuxt's
// error-page render path, which crashes downstream in `app:rendered` and the
// canonical-getter on this build.
export default {
  ssrCatchError: true,
} satisfies Partial<UseQueryOptionsGlobal>;
